import { motion } from "framer-motion";
import ScatterBackground from "@/components/ScatterBackground";

const BUY_URL =
  "https://dyorswap.org/launchInfo/?id=0x80c0e0d2e9985456475bE538bA5ddaB24A920000&chainId=5042";
const X_URL = "https://x.com/CATBATHATRATFAT";

export default function CTAFooter() {
  return (
    <section
      className="relative w-full overflow-hidden"
      style={{ backgroundColor: "var(--usdc-blue)", color: "var(--cream)" }}
      data-testid="cta-footer"
    >
      <ScatterBackground seed={57} count={30} />

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10 pt-24 pb-10">
        {/* Chapter tag */}
        <div className="flex items-baseline gap-4 text-white/80">
          <span className="font-editorial italic text-2xl md:text-3xl">§</span>
          <span className="font-mono text-[11px] uppercase tracking-[0.3em]">
            final chapter / press button
          </span>
        </div>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="font-display uppercase text-[18vw] md:text-[13vw] leading-[0.85] mt-4"
        >
          <span className="block">go on then.</span>
          <span
            className="block"
            style={{
              color: "transparent",
              WebkitTextStroke: "3px var(--cream)",
            }}
          >
            press it.
          </span>
        </motion.h2>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
          <div className="md:col-span-7">
            <p className="font-editorial italic text-2xl md:text-3xl max-w-[38ch] leading-tight">
              This is the button. It goes to the launch page. The launch page
              sells you a rat. The rat has wings. You already know.
            </p>
          </div>
          <div className="md:col-span-5 flex flex-col gap-4 items-start md:items-end">
            <a
              href={BUY_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-buy-button"
              className="inline-flex items-center gap-3 bg-[color:var(--meme-yellow)] text-[color:var(--ink)] font-display uppercase text-3xl md:text-4xl px-8 py-5 border-2 border-[color:var(--ink)] btn-shadow"
            >
              buy $usdc
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M5 12h14M13 5l7 7-7 7" />
              </svg>
            </a>
            <a
              href={X_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-x-button"
              className="inline-flex items-center gap-3 bg-[color:var(--ink)] text-[color:var(--cream)] font-display uppercase text-xl md:text-2xl px-6 py-4 border-2 border-[color:var(--ink)] btn-shadow"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2H21l-6.55 7.49L22 22h-6.828l-4.79-6.264L4.8 22H2l7.02-8.028L2 2h6.914l4.343 5.75L18.244 2Zm-1.196 18h1.635L7.05 3.9H5.31L17.048 20Z" />
              </svg>
              follow @CATBATHATRATFAT
            </a>
          </div>
        </div>

        {/* meta strip */}
        <div className="mt-24 border-t-2 border-white/40 pt-6 grid grid-cols-2 md:grid-cols-4 gap-6 font-mono text-[11px] uppercase tracking-widest text-white/85">
          <div>
            <div className="opacity-60">contract</div>
            <div className="mt-1 break-all">
              0x80c0e0d2e9985456475bE538bA5ddaB24A920000
            </div>
          </div>
          <div>
            <div className="opacity-60">chain</div>
            <div className="mt-1">ARC</div>
          </div>
          <div>
            <div className="opacity-60">ticker</div>
            <div className="mt-1">$USDC</div>
          </div>
          <div>
            <div className="opacity-60">status</div>
            <div className="mt-1">winged. fat. blue-hatted.</div>
          </div>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] uppercase tracking-widest text-white/70">
          <span>© {new Date().getFullYear()} USDC — the memecoin, not the boring one.</span>
          <span>this coin is a joke. the rat is not.</span>
        </div>
      </div>
    </section>
  );
}
